import { type components } from '@/generated/internal-api/openapi-types';
import type { AltId } from '@/model/Animal.model';
import type { Preset } from '@/model/Preset.model';
import type { WorkflowModelChild } from '@/components/Workflow/Show/Workflow.model';

export type WeightPercentageChange = components['schemas']['WeightPercentageChange.schema'];

export interface WorkflowTemplateDefaults {
  measurements?: {
    measurements?: Array<string>;
    weight_percentage_change?: WeightPercentageChange;
    assign_identifier?: AltId;
    after_save_action?: string;
    cursor_position?: string;
  };
  samples?: {
    auto_generate_sample_id?: boolean;
    samples?: Array<string>;
    after_save_action?: string;
  };
  observations?: {
    observations?: Array<string>;
    after_save_action?: string;
  };
  dosing?: {
    treatments?: Array<WorkflowModelChild>;
    after_save_action?: string;
    use_new_body_weight?: boolean;
    skip_dosing_for_unrequired_animals?: boolean;
  };
}
export type PercentChangeSettings = Record<Preset['id'], WeightPercentageChange>;

export const PercentChangeMap = {
  fromFirstMeasurement: 'first_measurement',
  fromLatestMeasurement: 'latest_measurement',
  fromMaximumMeasurement: 'maximum_measurement',
  trackingDate: 'tracking_date',
  diseaseInductionDate: 'disease_induction_date',
} satisfies Record<string, WeightPercentageChange>;

export const PercentChangeFromOptions: Array<{ value: WeightPercentageChange; label: string }> = [
  { value: 'first_measurement', label: 'First measurement' },
  { value: 'latest_measurement', label: 'Latest measurement' },
  { value: 'maximum_measurement', label: 'Max measurement' },
  { value: 'tracking_date', label: 'Tracking date' },
  { value: 'disease_induction_date', label: 'Disease induction date' },
];

export const getPercentChangeOptions = (
  maxWeightAlertsEnabled: boolean,
  dateBasedAlertsEnabled: boolean
): Array<{ value: WeightPercentageChange; label: string }> =>
  PercentChangeFromOptions.filter((option) => {
    if (option.value === 'maximum_measurement' && !maxWeightAlertsEnabled) {
      return false;
    }
    if (option.value === 'disease_induction_date' && !dateBasedAlertsEnabled) {
      return false;
    }
    return true;
  });
